<template>
    <v-client-table ref="filesTable" :data="files" :columns="columns" :options="options">
        <template slot="file_id" slot-scope="props">
            <a :href="`/files/${(props.row.download_only ? 'download' : 'view')}/${props.row.file_id}`" class="project-attachment-img" target="_blank">
                <img style="max-height: 30px; max-width: 30px;" v-bind:src="getThumbnail(props.row)" :ref="`file-${props.row.file_id}`">
            </a>

            <template v-if="!props.row.download_only">
                <a :href="`/files/view/${props.row.file_id}`" target="_blank" class="mr-1">View</a> |
            </template>
            <a :href="`/files/download/${props.row.file_id}`" target="_blank" class="mx-1">Download</a>
        </template>
        <template slot="user_id" slot-scope="props">
            {{ props.row.FirstName }} {{ props.row.LastName }}
        </template>
        <template slot="asset_type" slot-scope="props">
            {{ props.row.asset_type == 'EquipmentTracking' ? 'Tracking' : 'Equipment' }}
        </template>
        <template slot="created_at" slot-scope="props">
            <div v-if="props.row.tracking_date">
                {{ props.row.tracking_date | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
            </div>
            <div v-else>
                {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
            </div>
        </template>
    </v-client-table>
</template>

<script>
    export default {
        props: {
            files: {
                type: Array,
                required: true
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: ['file_id', 'file_name', 'user_id', 'asset_type', 'created_at'],
                options: {
                    headings: {
                        file_id: 'Actions',
                        file_name: 'File Name',
                        user_id: 'Uploader',
                        asset_type: 'Attached To',
                        created_at: 'Uploaded Date',
                    },
                    perPageValues: [],
                    sortable: ['file_name', 'created_at'],
                    columnsDropdown: false,
                    uniqueKey: 'file_id',
                },
            }
        },

        methods: {

            //Get the thumbnail preview
            getThumbnail(file){
                //Check if thumbnail was set on the backend
                if(file.thumbnail)
                {
                    return file.thumbnail;
                }

                //Setup
                var preview = null;

                //Switch
                switch(file.file_extension)
                {
                    case 'pdf':
                        preview = '/Images/file-type-pdf_256x256.png';
                        break;
                    case 'docx':
                    case 'doc':
                        preview = '/Images/file-type-docx_256x256.png';
                        break;
                    case 'xls':
                    case 'xlsx':
                        preview = '/Images/file-type-xlsx_256x256.png';
                        break;
                    default:
                        //Data should be a path, not a string - we converted those
                        // $path = $this->{$imageDataName};
                        // $type = pathinfo($path, PATHINFO_EXTENSION);
                        // $data = Storage::get($path);
                        // $preview = "data:image/".$type.";base64," . base64_encode($data);
                        this.loadThumbnail(file);

                        //Stop here
                        return '';
                        break;
                }

                //Stop here
                return preview;

                //Set the preview
                //this.$refs['file-' + file.file_id][0].src = preview;
            },

            loadThumbnail(file){
                //Send it
                this.$http.get('files/view/'+file.file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs['file-' + file.file_id].src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });
            },
        },

        mounted() {

        }
    }
</script>

<style>
    .project-attachment-file,
    .project-attachment-img {
        display: inline-block;
        -webkit-box-flex: 0;
        flex-grow: 0;
        flex-shrink: 0;
        overflow: hidden;
    }

    .project-attachment-file {
        display: inline-block;
        text-align: center;
        line-height: 4rem;
    }

    .project-attachment .media-body {
        display: inline-block;
    }
</style>
